import React from 'react'

import { ChipProps } from '@mui/material'

import * as S from './tag.styles'

export const Tag: React.FC<ChipProps> = (props) => {
  return <S.Tag {...props} deleteIcon={<S.DeleteIcon />} />
}
